import { Suspense, useEffect, useState } from 'react';
import './reset.css';
import './App.css';
import './Mobile.css';
import database from './temp.json';
import { app, db } from "./firebase";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { collection, getDocs } from "firebase/firestore";
import MainPage from './components/MainPage';
import Loading from './components/Loading';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';

function App() {
    var iframe;

    /*-------------------------------------------------------- Fetch data from DATABASE --------------------------------------------------------*/
    // const [data, setData] = useState(database); // FOR TESTING

    // const collections = ["furnitures", "materials"];
    // const fetchPost = async () => {
    //     for (let col of collections) {
    //         await getDocs(collection(db, col))
    //             .then((querySnapshot) => {
    //                 const newData = querySnapshot.docs
    //                     .map((doc) => {
    //                         const docData = doc.data();
    //                         // Exclure les champs spécifiques
    //                         const { createdby, createdate, lastupdate, updatedby, ...filteredData } = docData;
    //                         return { ...filteredData, id: doc.id };
    //                     });
    //                 setData(zeData => ({ ...zeData, [col]: newData }));
    //                 // console.log(data, newData);
    //             })
    //     }
    // }

    // useEffect(() => {
    //     fetchPost();
    // }, [])
    // useEffect(() => {
    //     console.log(data);
    // }, [data])
    /* END --------------------------------------------------- Fetch data from DATABASE --------------------------------------------------- END */

    /*---------------------------------------------------------- Fetch data from JSON ----------------------------------------------------------*/

    const [data, setData] = useState(); // FOR DISTRIBUTION
    const loadDataFromStorage = async () => {
        const storage = getStorage(app);
        const fileRef = ref(storage, 'data.json');

        try {
            const url = await getDownloadURL(fileRef);
            const response = await fetch(url);
            const jsonData = await response.json();
            // console.log(jsonData)
            setData(jsonData);
        } catch (error) {
            console.error("Error loading data from Cloud Storage:", error);
        }
    };
    useEffect(() => {
        loadDataFromStorage();
        // console.log("test")
    }, []);

    /* END ----------------------------------------------------- Fetch data from JSON ----------------------------------------------------- END */

    // ----------------------------------------------------------- INIT APP
    // function initIframe() {
    //     iframe = document.getElementById('appIframe');
    //     var i = iframe.contentWindow;
    //     i.addEventListener("initiatedApp", OnInitApp, false);
    //     /*i.addEventListener("OnModelBegin", OnModelBegin, false);
    //     i.addEventListener("OnModelEnd", OnModelEnd, false);*/
    // }
    // const OnInitApp = () => {
    //     iframe.contentWindow.setBackgroundColor("#F1EEEC");
    // }

    // ------------------------------------------------------ INIT APP [END]

    /*useEffect(() => {
        if (model !== null) {
            console.log(model.code);
        }
    }, [model])*/

    /*const OnModelEnd = () => {
        console.log("Model End");
    }
    const OnModelBegin = () => {
        console.log("Model Begin");
    }*/

    return (
        <Suspense fallback={<div />}>
            {data && <MainPage
                db={data}
            />}
        </Suspense>
        // <div className="App">
        //     {data === null && <Loading />}
        //     {data !== null && <MainPage
        //         categories={categories}
        //         active={cat}
        //         setActive={setCat}
        //         iframe={iframe}
        //         data={data}
        //         model={model}
        //         setModel={setModel}
        //         setIndex={setIndex}
        //         index={index}
        //     />
        //     }
        //     {/*<iframe id="appIframe" onLoad={() => initIframe()} src='./app/index.html?code=false' loading="lazy" ></iframe>*/}
        //     <iframe id="appIframe" onLoad={() => initIframe()} src='./app/index.html?code=false' loading="lazy" ></iframe>
        // </div>
    );
}

export default App;
